import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import logo from '../assets/img/logo.png';
import $ from 'jquery';
import list from '../constants/list';
import { getTreeMenu } from '../helpers/permissions';
import Menu from './menu';

class Navigation extends Component {
  constructor(props) {
    super(props);

    const { listMenu } = props;

    //console.log('navigationMenu > props',props);

    this.state = {
      menu: getTreeMenu(listMenu),
      navMenu: list.navMenu
    };

    this.configureMenu();
  }

  componentDidMount() {
    this.configureMenu();
  }

  configureMenu = () => {
    const { menu } = this.refs;
    // eslint-disable-next-line func-names
    $(function () {
      $(menu).metisMenu({
        toggle: true
      });
    });
  };

  // componentWillUpdate() {
  //   $('body').toggleClass('mini-navbar');
  //   smoothlyMenu();
  // }

  render() {
    return (
      <nav className="navbar-default navbar-static-side" role="navigation">
        <div className="sidebar-collapse">
          <ul className="nav metismenu" id="side-menu" ref="menu" style={{ zIndex: 2000 }}>
            <li className="nav-header">
              {this.profile()}
              <div className="logo-element">
                {' '}
                <img alt="" className="logo-v" src={logo} />{' '}
              </div>
            </li>
            {this.menu()}
          </ul>
        </div>
      </nav>
    );
  }

  profile = () => {
    return (
      <div className="dropdown profile-element">
        <img alt="" className="logo-h" src={logo} />
        {/* <span data-toggle="dropdown" className="dropdown-toggle" style={{ cursor: 'pointer' }}>
          <span className="block m-t-xs font-bold">Mir Nawaz</span>
          <span className="text-muted text-xs block">Software Dev <b className="caret" /></span>
        </span>
        <ul className="dropdown-menu animated  m-t-xs">
          {this.state.navMenu.map((menu, index) => {
            if (menu.divider) {
              return (<li key={index} className="dropdown-divider" />);
            }
            return (<li key={index}><Link className="dropdown-item" to={menu.path}>{menu.label}</Link></li>);
          })}
        </ul> */}
      </div>
    );
  };

  menu = () => {
    return <Menu menu={this.state.menu} />;
  };
}

const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Navigation);
